//Hero Accordion Slider
const panels = document.querySelectorAll(".panel");

panels.forEach((panel) => {
  panel.addEventListener("mouseenter", () => {
    removeActiveClasses();
    panel.classList.add("active");
  });
});

function removeActiveClasses() {
  panels.forEach((panel) => {
    panel.classList.remove("active");
  });
}
//End Hero Accordion SLider

// mutation contact us
document.addEventListener('DOMContentLoaded', function() {
  function adjustHeight() {
      var row = document.querySelector('.equal-height-row');
      var cols = row.querySelectorAll('.equal-height-col');
      var maxHeight = 0;

      // Reset heights
      cols.forEach(function(col) {
          col.style.height = 'auto';
      });

      // Find max height
      cols.forEach(function(col) {
          var height = col.offsetHeight;
          maxHeight = height > maxHeight ? height : maxHeight;
      });

      // Set all columns to max height
      cols.forEach(function(col) {
          col.style.height = maxHeight + 'px';
      });
  }

  // Adjust heights on load and resize
  window.addEventListener('load', adjustHeight);
  window.addEventListener('resize', adjustHeight);
});